var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M20 16a4 4 0 1 1-4-4 4.013 4.013 0 0 1 4 4Zm8.5-5.5v11a7 7 0 0 1-7 7h-11a7 7 0 0 1-7-7v-11a7 7 0 0 1 7-7h11a7 7 0 0 1 7 7ZM22 16a6 6 0 1 0-12 0 6 6 0 0 0 12 0Zm2-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"}));
}

Instagram.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = Instagram;

Instagram.default = Instagram;
